import React, { useEffect } from 'react';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import Icon from '../react/Atoms/Icon';
import { DEFAULT_BACKUP_CULTURE, updateCultureSettings } from '../../util/culture';

const propTypes = exact({
  cultures: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentCulture: PropTypes.string.isRequired,
  alternativeUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
  fallbackCulture: PropTypes.string,
});

const defaultProps = {
  fallbackCulture: DEFAULT_BACKUP_CULTURE,
};

function LanguageSwitch({ cultures, currentCulture, alternativeUrls, fallbackCulture }) {
  useEffect(() => {
    updateCultureSettings(currentCulture, fallbackCulture);
  }, [currentCulture, fallbackCulture]);

  const handleLanguageChange = (event) => {
    const selectedCulture = event.target.value;
    const urlToNavigate = alternativeUrls.find((url) => url.startsWith(`/${selectedCulture}/`));
    const currentSearchParams = window.location.search;
    if (urlToNavigate) {
      window.location.href = `${urlToNavigate}${currentSearchParams}`;
    } else {
      console.error('No URL found for the selected culture:', selectedCulture);
    }
  };

  return (
    <>
      <Icon id="globe" blockName="Navigation_globeIcon" />
      <label htmlFor="language-select" className="visually-hidden">
        Select Language
      </label>
      <select
        id="language-select"
        className="Navigation_selectElement"
        onChange={handleLanguageChange}
        defaultValue={currentCulture}
        aria-label="Select Language"
      >
        {cultures.map((culture) => (
          <option className="Navigation_selectOption" key={culture} value={culture}>
            {culture}
          </option>
        ))}
      </select>
    </>
  );
}

LanguageSwitch.propTypes = propTypes;
LanguageSwitch.defaultProps = defaultProps;

export default LanguageSwitch;
